module.exports = __webpack_public_path__ + "static/media/footerTime.ae11cc33.svg";